import { useTranslation } from 'react-i18next';

import ActiveContacts from './components/ActiveContacts/ActiveContacts';
import AwaitingStartClientData from './components/AwaitingStartClientData/AwaitingStartClientData';
import ClientDataCardError from './components/ClientDataCardError/ClientDataCardError';
import ClientDataCardSkeleton from './components/ClientDataCardSkeleton/ClientDataCardSkeleton';
import ExpandableCard from '../../../../../../shared/components/Cards/ExpandableCard/ExpandableCard';
import { useClientContacts } from '../../../../../../shared/hooks/useClientContacts/useClientContacts';
import { TRANSLATIONS_CLIENTS } from '../../../../../../shared/translations/clients';
import { ClientsStatus } from '../../../../../../shared/types/clients';

import '../../../../../../shared/components/ProfileCards/ClientDataCardLayout/ClientDataCardLayout.scss';
import '../../../../../../shared/components/ProfileCards/ProfileCard/ProfileCard.scss';

const PROFILE = TRANSLATIONS_CLIENTS.profile;

interface IClientDataCardProps {
  status: ClientsStatus | null;
  id: number | null;
}

const ClientDataCard = ({ status, id }: IClientDataCardProps) => {
  const { t } = useTranslation();
  const { data, loading, error, retry } = useClientContacts(status, id);

  const renderExpandibleCard = (children: React.ReactNode) => {
    return (
      <ExpandableCard
        className="client-profile-data-card"
        title={t(PROFILE.sections.clientData)}
        defaultExpanded={false}
      >
        {children}
      </ExpandableCard>
    );
  };

  if (loading) {
    return renderExpandibleCard(<ClientDataCardSkeleton />);
  }

  if (!data || error) {
    return renderExpandibleCard(<ClientDataCardError onRetry={retry} />);
  }

  if (data.status === ClientsStatus.Active) {
    return renderExpandibleCard(<ActiveContacts contacts={data.contacts} />);
  }

  return renderExpandibleCard(<AwaitingStartClientData prospect={data.prospect} />);
};

export default ClientDataCard;
